import { Component } from "@angular/core";
import { MessageService } from "base";
import { AuditLogService } from "configuration/services/audit-log.service";
import { ConfigurationService } from "configuration/services/configuration.service";
import { AuditLogEntryListDto } from "UvExplorerServer.Dtos.TS/AuditLogging/AuditLogEntryListDto";
import { AuditLogSettingsDto } from "UvExplorerServer.Dtos.TS/Configuration/AuditLogSettingsDto";



@Component({
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss'],
  selector: 'audit-log',
  providers: [AuditLogService]
})
export class AuditLogComponent {

    settings: AuditLogSettingsDto = new AuditLogSettingsDto();

    activeIndex = 1;

    constructor(
        private configurationService: ConfigurationService, 
        private messageService: MessageService, 
        private auditLogService: AuditLogService) {

    }

    ngOnInit(){
        this.getAuditLogSettings();
    }

    private getAuditLogSettings(){
        this.configurationService.getAuditLogSettings().subscribe (
            data => {
                this.settings = data;
            },
            error => {
                console.error(error);
                this.messageService.displayErrorMessage("Failed to get audit log settings");
            }
        )
    }

   saveAuditLogSettings(){
        this.configurationService.setAuditLogSettings(this.settings).subscribe(
            data => {},
            error => this.messageService.displayErrorMessage("Failed to update")
        );
    }


}

